import styled from 'styled-components';
import { FlexView, Row } from '@cuemath/comps';
import { Text } from '@cuemath/web-comps';
import COLORS from 'constants/colors';

// ── Color Palette ───────────────────────────────────────────────────
const SA = {
  BG_PRIMARY: COLORS.CREAM_BG,
  BG_SECONDARY: COLORS.CREAM_BG_2,
  BG_TERTIARY: COLORS.CREAM_BG_3,

  TEXT_PRIMARY: COLORS.ABBEY,
  TEXT_SECONDARY: COLORS.BLACK_65,
  TEXT_TERTIARY: COLORS.ASH,

  BORDER_PRIMARY: COLORS.CREAM_BORDER_3,
  BORDER_SECONDARY: COLORS.CREAM_BORDER_2,
  BORDER_TERTIARY: COLORS.CREAM_BORDER,

  GOLD_50: COLORS.GOLD_50,
  GOLD_100: COLORS.GOLD_100,
  GOLD_200: COLORS.GOLD_200,
  GOLD_300: COLORS.GOLD_300,
  GOLD_500: COLORS.GOLD_500,
  GOLD_700: COLORS.GOLD_700,
  GOLD_900: COLORS.GOLD_900,

  INFO_50: COLORS.SKY_XXLIGHT,
  INFO_100: COLORS.BLUE_1,
  INFO_200: COLORS.HAWKESBLUE,
  INFO_300: COLORS.ASH_1,
  INFO_600: COLORS.PRIMARY,
  INFO_700: COLORS.SCIENCEBLUE,
  INFO_900: COLORS.ABBEY,

  ERROR_50: COLORS.RED_1,
  ERROR_100: COLORS.RED_1,
  ERROR_200: COLORS.RED_2,
  ERROR_400: COLORS.RED_4,
  ERROR_600: COLORS.NEGATIVE,
  ERROR_700: COLORS.RUSTY_RED,
  ERROR_900: COLORS.RED_6,

  SUCCESS_100: COLORS.GREEN_1,
  SUCCESS_200: COLORS.GREEN_2,
  SUCCESS_700: COLORS.GREEN_6,

  WARNING_100: COLORS.WARNING_BG,
  WARNING_300: COLORS.WARNING_BORDER,
  WARNING_700: COLORS.WARNING_TEXT,
  WARNING_900: COLORS.YELLOW_6,

  NEUTRAL_100: COLORS.WHITE_3,
  NEUTRAL_300: COLORS.WHITE_5,
  NEUTRAL_500: COLORS.GRAY,
  NEUTRAL_1000: COLORS.ABBEY,
};

export { SA as SA_COLORS };

// ── Thread ──────────────────────────────────────────────────────────
export const ThreadContainer = styled(FlexView)`
  && {
    min-width: 0;
    min-height: 0;
    height: 100%;
    background: ${SA.BG_PRIMARY};
  }
`;

export const ThreadScroll = styled(FlexView)`
  && {
    flex: 1;
    overflow: auto;
    padding: 24px 48px;

    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background: ${SA.BORDER_PRIMARY};
    }
  }
`;

export const ThreadInner = styled(FlexView)`
  && {
    max-width: 820px;
    margin: auto auto 0;
    width: 100%;
    gap: 24px;
  }
`;

export const DateSeparator = styled(Row)`
  && {
    align-items: center;
    gap: 12px;
    padding: 4px 0;
  }

  &::before,
  &::after {
    content: '';
    flex: 1;
    height: 1px;
    background: ${SA.BORDER_TERTIARY};
  }
`;

export const DateSeparatorLabel = styled(Text)`
  && {
    font-size: 11px;
    font-weight: 600;
    color: ${SA.TEXT_TERTIARY};
    white-space: nowrap;
  }
`;

export const TicketCardHead = styled(Row)`
  && {
    align-items: center;
    gap: 8px;
  }
`;
